import { jsx as _jsx } from "react/jsx-runtime";
import { ArabicFormatAddress } from './formats/ArabicFormatAddress';
import { DefaultFormatAddress } from './formats/DefaultFormatAddress';
import { EastAsiaFormatAddress } from './formats/EastAsiaFormatAddress';
import { EuropeanFormatAddress } from './formats/EuropeanFormatAddress';
export const Address = ({ isFullAddress = true, locale, address, isAddressTypeDisplay = false, translatedAddressType, isAsianOrder, translatedPostalSymbol }) => {
    switch (locale) {
        case 'ar_EG':
            return (_jsx(ArabicFormatAddress, { address: address, isFullAddress: isFullAddress, isAddressTypeDisplay: isAddressTypeDisplay, translatedAddressType: translatedAddressType }));
        case 'ja_JP':
        case 'ko_KR':
        case 'zh_CN':
        case 'zh_TW':
            return (_jsx(EastAsiaFormatAddress, { address: address, isFullAddress: isFullAddress, isAddressTypeDisplay: isAddressTypeDisplay, translatedAddressType: translatedAddressType, isAsianOrder: isAsianOrder, translatedPostalSymbol: translatedPostalSymbol }));
        case 'de_DE':
        case 'es_ES':
        case 'fr_FR':
        case 'it_IT':
        case 'pl_PL':
        case 'ro_RO':
        case 'ru_RU':
            return (_jsx(EuropeanFormatAddress, { address: address, isFullAddress: isFullAddress, isAddressTypeDisplay: isAddressTypeDisplay, translatedAddressType: translatedAddressType }));
        default:
            return (_jsx(DefaultFormatAddress, { address: address, isFullAddress: isFullAddress, isAddressTypeDisplay: isAddressTypeDisplay, translatedAddressType: translatedAddressType, isAsianOrder: isAsianOrder }));
    }
};
